import React from "react";
import { Button } from "@/components/ui/button";
import { Save, Check } from "lucide-react";

interface PaymentModalityActionsProps {
  isSaving: boolean;
  lastSaved?: Date;
  onSave: () => Promise<void>;
  onRecommended: () => void;
}

export function PaymentModalityActions({
  isSaving,
  lastSaved,
  onSave,
  onRecommended,
}: PaymentModalityActionsProps) {
  return (
    <>
      <div className="flex gap-2 pt-2">
        <Button
          variant="default"
          size="sm"
          onClick={onSave}
          disabled={isSaving}
          className="flex-1"
        >
          {isSaving ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" />
              Sauvegarde...
            </>
          ) : lastSaved ? (
            <>
              <Check className="w-4 h-4 mr-2" />
              Sauvegardé
            </>
          ) : (
            <>
              <Save className="w-4 h-4 mr-2" />
              Sauvegarder
            </>
          )}
        </Button>

        <Button
          variant="outline"
          size="sm"
          onClick={onRecommended}
          className="px-3 border-primary text-primary hover:bg-primary hover:text-white"
        >
          ⭐ Recommandé
        </Button>
      </div>

      {lastSaved && (
        <div className="text-xs text-muted-foreground text-center">
          Dernière sauvegarde : {lastSaved.toLocaleTimeString("fr-FR")}
        </div>
      )}
    </>
  );
}

export default PaymentModalityActions;
